module.exports = __webpack_public_path__ + "bd.svg?6fa55e57b26bd046ad9edbfef28c4c92";